import {Link as RRDLink} from 'react-router-dom'
import invariant from 'invariant'
import {createLocation} from 'history'
import isUrl from 'validator/es/lib/isURL'

import './Link.css'

export default class Link extends RRDLink {
  static defaultProps = {
    ...RRDLink.defaultProps,
    scrollTop: true,
    disabled: false
  }

  gotoTop() {
    const tag = document.querySelectorAll('html,body')
    for (let i = 0; i < tag.length; i++) {
      tag[i].scrollTop = 0
    }
  }

  _handleClick = (event) => {
    if (this.props.disabled) {
      event.preventDefault()
      return
    }

    this.handleClick(event)
    if (event.defaultPrevented && this.props.scrollTop) {
      this.gotoTop()
    }
  }

  getHref = (to, isUrl) => {
    if (isUrl) {
      return to
    }

    const {history} = this.context.router
    const location = typeof to === 'string' ? createLocation(to, null, null, history.location) : to
    return history.createHref(location)
  }

  render() {
    const {replace, to, innerRef, scrollTop, children, className, disabled, ...props} = this.props // eslint-disable-line no-unused-vars

    invariant(
      this.context.router,
      'You should not use <Link> outside a <Router>'
    )

    const classNames = [(className || '')]
    if (disabled) {
      classNames.push('disabled')
    }

    const isURL = isUrl(to)
    const linkProps = {
      ...props,
      href: this.getHref(to, isURL)
    }

    if (isURL) {
      linkProps.target = '_blank'
      linkProps.rel = 'noopener noreferrer'
    } else {
      linkProps.onClick = this._handleClick
    }

    return <a {...linkProps} ref={innerRef} className={classNames.join(' ')}>{children}</a>
  }
}
